export default "__VITE_ASSET__CRiwShjY__"